import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./landingpage.css";
import Footer from "../../components/Footer/Footer";
import PremiumHeader from "../../components/Header/PremiumHeader";
import CircularSlider from "../../components/CircularSliding/CircularSlider";
import { useLang, t } from "../../context/LanguageContext";
import T from "../../translations/index";
import welcome from "../../assets/logos/welcome.png";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// --- Work images ---
import work1 from "../../assets/works/work1.jpg";
import work2 from "../../assets/works/work2.jpg";
import work3 from "../../assets/works/work3.jpg";
import work4 from "../../assets/works/work4.jpg";
import work5 from "../../assets/works/work5.jpg";
import work6 from "../../assets/works/work6.jpg";
import work7 from "../../assets/works/work7.jpg";
import work8 from "../../assets/works/work8.jpg";
import work9 from "../../assets/works/work9.jpg";
import work10 from "../../assets/works/work10.jpg";

// --- Client logos ---
import client1 from "../../assets/logos/client1.png";
import client2 from "../../assets/logos/client2.png";
import client3 from "../../assets/logos/client3.png";
import client4 from "../../assets/logos/client4.png";
import client5 from "../../assets/logos/client5.png";
import client6 from "../../assets/logos/client6.png";
import client7 from "../../assets/logos/client7.png";
import client8 from "../../assets/logos/client8.png";
import client9 from "../../assets/logos/client9.png";
import client10 from "../../assets/logos/client10.png";
import tataPowerLogo from "../../assets/logos/tata power.png";
import steagLogo from "../../assets/logos/steag.png";

const workImages = [work1,work2,work3,work4,work5,work6,work7,work8,work9,work10];
const clientLogos = [client1,client2,client3,client4,client5,client6,client7,client8,client9,client10,tataPowerLogo,steagLogo];

// ── Services data ──────────────────────────────────────────────────
// eslint-disable-next-line no-unused-vars
const serviceIcons = ["🔥","⚡","⛏️","🏭","🌊","🏗️","🔧","🌿"];
const constructionWorks = [
  {
    icon: "🔥", title: "Boiler Works",
    description: "Complete scope of boiler-related works including piping, pressure parts, internal components, structural works, ducting, economizer, and APH installation.",
    subItems: [
      { name: "All Kind of Piping Works", details: "MS, CS, SS & Alloy steel pipes | Range: 25mm – 2000mm dia | SCH 20–160 | Welding, NDT & Hydro testing", manpower: "Fitter, Welder (IBR & Non-IBR), Rigger, Helper" },
      { name: "Boiler Pressure Part (IBR) Works", details: "Headers, Steam Drums, Water Walls, Superheaters, Reheaters | Thickness 5mm–120mm | As per IBR code", manpower: "IBR Certified Welders, QA/QC Engineer, Radiography Team" },
      { name: "Internal Components & Equipment Installation", details: "Water walls, Furnace panels, Burner assemblies, Superheater coils, Safety valves & Supports", manpower: "Welder, Fitter, Millwright, Inspector" },
      { name: "Structural Works", details: "Boiler supporting structures, Columns, Beams, Platforms, Staircases up to 120m height", manpower: "Fabricator, Structural Fitter, Welder, Rigger" },
      { name: "Duct Management", details: "Flue gas ducts, Expansion joints, Dampers, Hopper ducts | Thickness 4mm–20mm", manpower: "Fabricator, Gas Cutter, Welder, Erection Team" },
      { name: "Economizer Installation", details: "Tube bundles, Headers, Casings | Hydro testing & alignment", manpower: "Tube Welder, Fitter, QA/QC Inspector" },
      { name: "Air Pre-Heater (APH)", details: "Rotary/Ljungstrom APH | Basket installation, Seals & Drive unit alignment", manpower: "Fitter, Welder, Millwright, Mechanical Supervisor" }
    ]
  },
  {
    icon: "⚡", title: "ESP (Electrostatic Precipitator)",
    description: "Complete ESP works including hopper erection, equipment installation, and associated piping systems.",
    subItems: [
      { name: "Hopper Installation", details: "ESP hoppers, discharge gates, insulation & alignment works", manpower: "Fabricator, Fitter, Welder, Rigger" },
      { name: "Electrode Installation", details: "Discharge electrodes, Collecting electrodes, Emitting electrodes with alignment & tensioning", manpower: "Electrode Fitter, Welder, QA/QC Inspector" },
      { name: "GD Screen & Hampers", details: "Gas distribution (GD) screens, Hampers, Flow alignment works", manpower: "Fitter, Gas Cutter, Fabricator, Supervisor" },
      { name: "Filter Bag & Internal Equipment", details: "FF Bag installation, Casing internals, Seals, Access doors", manpower: "Filter Bag Technician, Welder, Helper, Safety Officer" },
      { name: "Related Piping Works", details: "Ash handling piping, Cooling water piping | Range: 25mm – 600mm dia", manpower: "Pipe Fabricator, IBR/Non-IBR Welder, Pipe Fitter, Helper" }
    ]
  },
  {
    icon: "⛏️", title: "Coal Handling & Storage System",
    description: "Works related to coal conveyors, crusher houses, stockyards and bunkers.",
    subItems: [
      { name: "Conveyor System Installation", details: "Length: up to 5km | Belt width: 800–2000mm", manpower: "Conveyor Erector, Fitter, Welder, Helper" },
      { name: "Crusher House Erection", details: "Structural + machine installation | Feed size: 300mm", manpower: "Mechanical Fitter, Welder, Rigger" },
      { name: "Coal Bunker Fabrication", details: "Capacity: 1000–3000T | Mild steel fabrication", manpower: "Fabricator, Welder, Crane Operator" },
      { name: "Stacker & Reclaimer Works", details: "Stacker boom length up to 40m | Reclaimer capacity 3000T/hr", manpower: "Heavy Mechanic, Electrical Fitter, Operator" },
      { name: "Dust Suppression & Fire Fighting Piping", details: "MS/CS/SS pipelines | Dia: 25mm – 1200mm", manpower: "Pipe Fitter, Welder, Rigger, Helper" }
    ]
  },
  {
    icon: "🏭", title: "Ash Management System",
    description: "Complete fly ash and bottom ash handling system including hoppers, silos, slurry & pneumatic pipelines.",
    subItems: [
      { name: "Bottom Ash Hopper Installation", details: "Heavy steel hoppers with refractory lining | Capacity up to 500T", manpower: "Welder, Fabricator, Rigger, Refractory Specialist" },
      { name: "Buffer Hopper Works", details: "Intermediate ash storage hoppers | Insulation & sealing", manpower: "Fitter, Welder, QA/QC Inspector" },
      { name: "Ash Slurry Piping", details: "Slurry pipelines: Dia 200mm – 1000mm | Rubber lined & CS pipes", manpower: "Pipe Fitter, Welder, Lining Specialist, Rigger" },
      { name: "Fly Ash Silo & Pneumatic Conveying", details: "Silos up to 5000T | Dense phase system", manpower: "Structural Welder, Instrumentation Fitter, Supervisor" },
      { name: "HPHS & LPHS Works", details: "High & low pressure hydro-sluicing systems", manpower: "Pump Erector, Pipe Welder, Mechanical Fitter" }
    ]
  },
  {
    icon: "🌊", title: "Cooling Tower Works",
    description: "Mechanical scope of cooling tower works including erection, piping, and associated equipment installation.",
    subItems: [
      { name: "Cooling Tower Mechanical Erection", details: "FRP/Concrete towers | Basin, Fill media, Drift eliminators", manpower: "Mechanical Fitter, Welder, Crane Operator, Rigger" },
      { name: "Cooling Water Pipeline Works", details: "Large bore dia 1000mm – 3000mm piping | CS & MS pipes", manpower: "Pipe Fitter, Heavy Welder, Rigger, Helper" },
      { name: "Fan Deck & Drive System", details: "Fan blades, shafts, gearboxes, couplings & alignment", manpower: "Millwright, Mechanical Fitter, Alignment Engineer" },
      { name: "CW Pump House Works", details: "Pump foundation, erection, discharge & suction piping", manpower: "Pump Erector, Pipe Fitter, Welder, Supervisor" }
    ]
  },
  {
    icon: "🏗️", title: "Chimney Works",
    description: "Mechanical scope of high-rise chimney works including shell erection, flue ducting, internal lining.",
    subItems: [
      { name: "Chimney Shell Erection (Steel)", details: "Height up to 275m | Plate rolling, welding, lifting", manpower: "Structural Welder, Plate Fabricator, Crane Operator, Height Safety Officer" },
      { name: "Flue Gas Ducting & Expansion Joints", details: "Heavy steel ducts | Size up to 10m x 8m", manpower: "Fabricator, Welder, Gas Cutter, Rigger" },
      { name: "Platforms, Ladders & Cages", details: "Steel platforms, access ladders, spiral staircases, safety cages", manpower: "Structural Fitter, Welder, Rigger, Safety Supervisor" },
      { name: "Internal Lining Works", details: "Refractory brick lining, Castable lining, Acid-resistant tiles", manpower: "Refractory Mason, Welder, Helper, QA/QC Inspector" }
    ]
  },
  {
    icon: "🔧", title: "Shutdown & Maintenance",
    description: "Planned and emergency shutdown maintenance services for thermal power plant systems.",
    subItems: [
      { name: "Boiler Shutdown Maintenance", details: "Tube replacement, header repairs, inspection & hydro testing", manpower: "IBR Welder, Fitter, NDT Inspector" },
      { name: "Turbine & Generator Maintenance", details: "Alignment, bearing replacement, seal maintenance", manpower: "Millwright, Mechanical Engineer, Supervisor" },
      { name: "Electrical & Instrumentation", details: "Panel maintenance, cable tray works, instrumentation calibration", manpower: "Electrician, Instrument Technician, Helper" }
    ]
  },
  {
    icon: "🌿", title: "Area Development & Horticulture",
    description: "Landscaping, greening, and area development works for industrial townships and power projects.",
    subItems: [
      { name: "Township Landscaping", details: "Garden development, tree plantation, lawn creation", manpower: "Horticulture Expert, Gardener, Labour" },
      { name: "Road & Drainage Works", details: "Internal roads, RCC drains, culverts", manpower: "Civil Engineer, Foreman, Labour" }
    ]
  }
];

const clientsList = [
  { name: "TPSC (Toshiba Power)", type: "Power Project", description: "TPSC Anuppur — Major thermal power project with full mechanical contracting" },
  { name: "Lanco Infratech Ltd.", type: "Power Project", description: "Korba coal-based thermal power plant with structural and equipment works" },
  { name: "Vedanta Aluminium & Power", type: "Power Project", description: "Jharsuguda project with complete mechanical installation services" },
  { name: "Adani Power Ltd.", type: "Power Project", description: "Multiple locations — Full mechanical works and infrastructure services" },
  { name: "NTPC", type: "Power Project", description: "Tandwa, Buxar, NKSTPP — Major power generation projects" },
  { name: "Tata Power Jamshedpur", type: "Power Project", description: "Cooling tower works, piping, and equipment erection" },
  { name: "Ambuja Cement", type: "Cement Project", description: "Bhatapara cement plant with mechanical and material handling systems" },
  { name: "CLP India Pvt Ltd", type: "Power Project", description: "Jhajjar, Haryana plant with coal handling and ash management solutions" }
];

const statsData = [
  { icon: "🏆", num: 14, suffix: "+", labelKey: "statsYears" },
  { icon: "🏗️", num: 50, suffix: "+", labelKey: "statsProjects" },
  { icon: "🤝", num: 12, suffix: "+", labelKey: "statsClients" },
  { icon: "🗺️", num: 8,  suffix: "+", labelKey: "statsStates" },
];

// ── Custom hook: IntersectionObserver ──────────────────────────────
function useScrollReveal(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect(); }
    }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
}

// ── Animated counter ───────────────────────────────────────────────
function AnimatedCounter({ target, suffix, visible }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!visible) return;
    let start = 0;
    const duration = 1600;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [visible, target]);
  return <span>{count}{suffix}</span>;
}

// ── Service Detail Modal ───────────────────────────────────────────
const ServiceModal = ({ category, onClose }) => {
  if (!category) return null;
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: "20px", overflow: "hidden", background: "#fff", boxShadow: "0 30px 100px rgba(0,0,0,0.3)" } }}
    >
      <DialogTitle sx={{ p: 0,
        background: "linear-gradient(135deg,#0b1a3e 0%,#1e3a8a 50%,#2563eb 100%)",
        position: "relative", overflow: "hidden"
      }}>
        <Box sx={{ px: 3, pt: 2.5, pb: 2, display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography sx={{ fontSize: "1.3rem", fontWeight: 800, color: "#fff", lineHeight: 1.2, mb: 0.5 }}>
              {category.icon} {category.title}
            </Typography>
            <Typography sx={{ fontSize: "0.82rem", color: "rgba(255,255,255,0.6)", fontStyle: "italic" }}>
              {category.description}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small"
            sx={{ color: "rgba(255,255,255,0.75)", background: "rgba(255,255,255,0.1)", ml: 2, flexShrink: 0,
              "&:hover": { background: "rgba(255,255,255,0.2)", transform: "rotate(90deg)", transition: "all 0.22s ease" }
            }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: "20px", background: "#f8faff" }}>
        {category.subItems.map((item, idx) => (
          <Box key={idx} sx={{ mb: 1.5, p: "14px 16px", borderRadius: "12px", background: "#fff",
            border: "1.5px solid #e2e8f0",
            transition: "all 0.2s ease",
            "&:hover": { borderColor: "#bfdbfe", transform: "translateX(3px)", boxShadow: "0 4px 16px rgba(37,99,235,0.1)" }
          }}>
            <Typography sx={{ fontWeight: 800, fontSize: "0.92rem", color: "#0b1a3e", mb: 1 }}>
              {item.name}
            </Typography>
            <Box sx={{ display: "flex", gap: 1, mb: 0.6, alignItems: "flex-start" }}>
              <Typography component="span" sx={{ fontSize: "0.65rem", fontWeight: 800, color: "#fff",
                background: "linear-gradient(135deg,#1e3a8a,#2563eb)", px: "7px", py: "2px",
                borderRadius: "6px", flexShrink: 0, mt: "1px", textTransform: "uppercase" }}>
                Details
              </Typography>
              <Typography sx={{ fontSize: "0.82rem", color: "#475569", lineHeight: 1.6 }}>{item.details}</Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
              <Typography component="span" sx={{ fontSize: "0.65rem", fontWeight: 800, color: "#fff",
                background: "linear-gradient(135deg,#0d9488,#14b8a6)", px: "7px", py: "2px",
                borderRadius: "6px", flexShrink: 0, mt: "1px", textTransform: "uppercase" }}>
                Team
              </Typography>
              <Typography sx={{ fontSize: "0.82rem", color: "#475569", lineHeight: 1.6 }}>{item.manpower}</Typography>
            </Box>
          </Box>
        ))}
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 2, background: "#f8faff", borderTop: "1.5px solid #e2e8f0" }}>
        <Button onClick={onClose} variant="contained"
          sx={{ background: "linear-gradient(135deg,#0b1a3e,#2563eb)", color: "#fff",
            fontWeight: 700, textTransform: "none", borderRadius: "50px", px: 3.5, py: 1,
            "&:hover": { background: "linear-gradient(135deg,#060d1f,#1d4ed8)", transform: "translateY(-1px)" }
          }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

// ═══════════════════════════════════════════════════════════════════
//  MAIN LANDING PAGE
// ═══════════════════════════════════════════════════════════════════
const LandingPage = () => {
  const navigate = useNavigate();
  const { lang } = useLang();
  const [selectedService, setSelectedService] = useState(null);

  // Scroll-reveal refs
  const [statsRef, statsVisible] = useScrollReveal(0.2);
  const [aboutRef, aboutVisible] = useScrollReveal(0.15);
  const [servicesRef, servicesVisible] = useScrollReveal(0.1);
  const [clientsRef, clientsVisible] = useScrollReveal(0.1);
  const [contactRef, contactVisible] = useScrollReveal(0.15);
  const [workRef, workVisible] = useScrollReveal(0.15);
  const [trustRef, trustVisible] = useScrollReveal(0.15);
  const [projectsRef, projectsVisible] = useScrollReveal(0.1);

  return (
    <div className="landing-page">
      <PremiumHeader />

      {/* ─── HERO ───────────────────────────────────────────── */}
      <section className="lp-hero" id="home" aria-label="Hero section">
        <div className="lp-hero-bg" aria-hidden="true" />
        <div className="lp-hero-grid" aria-hidden="true" />
        <div className="lp-hero-orb" aria-hidden="true" />
        <div className="lp-hero-orb" aria-hidden="true" />
        <div className="lp-hero-orb" aria-hidden="true" />

        <div className="lp-hero-content">
          <div className="lp-hero-left">
            <div className="lp-hero-eyebrow">
              <span className="lp-hero-eyebrow-dot" aria-hidden="true" />
              Established 2010 · Jamshedpur, India
            </div>
            <h1 className="lp-hero-headline">
              {t(T.heroHeadline, lang).split(" ").map((word, i) =>
                i === 2 || i === 3 ? <span key={i} className="lp-hero-headline-gold"> {word}</span> : ` ${word}`
              )}
            </h1>
            <p className="lp-hero-sub">{t(T.heroSub, lang)}</p>
            <div className="lp-hero-badges">
              <span className="lp-hero-badge lp-hero-badge-gold">🇮🇳 {t(T.dpiit, lang)}</span>
              <span className="lp-hero-badge lp-hero-badge-teal">{t(T.msme, lang)}</span>
              <span className="lp-hero-badge">14+ Years Excellence</span>
            </div>
            <div className="lp-hero-cta">
              <button className="lp-cta-btn lp-cta-btn-workforce" onClick={() => navigate("/careers")}
                aria-label="Join our workforce - Apply for a job">
                <span className="lp-cta-icon" aria-hidden="true">👷</span>
                <span className="lp-cta-text">
                  <span className="lp-cta-label">{t(T.heroJoin, lang)}</span>
                  <span className="lp-cta-sub">{t(T.heroJoinSub, lang)}</span>
                </span>
              </button>
              <button className="lp-cta-btn lp-cta-btn-hire" onClick={() => navigate("/hireus")}
                aria-label="Hire our team - Business enquiry">
                <span className="lp-cta-icon" aria-hidden="true">🏭</span>
                <span className="lp-cta-text">
                  <span className="lp-cta-label">{t(T.heroHire, lang)}</span>
                  <span className="lp-cta-sub">{t(T.heroHireSub, lang)}</span>
                </span>
              </button>
            </div>
          </div>

          <div className="lp-hero-right">
            <div className="lp-hero-img-wrap">
              <img src={welcome} alt="Trishivanay Construction — Thermal Power Plant Projects" className="lp-hero-img" />
            </div>
          </div>
        </div>

        <div className="lp-hero-scroll" aria-hidden="true">
          <span>Scroll</span>
          <div className="lp-hero-scroll-arrow">↓</div>
        </div>
      </section>

      {/* ─── STATS ──────────────────────────────────────────── */}
      <section className="lp-stats" aria-label="Company statistics" ref={statsRef}>
        <div className="lp-container">
          <div className="lp-stats-grid">
            {statsData.map((s, i) => (
              <div className={`lp-stat lp-animate lp-animate-delay-${i+1}${statsVisible ? " lp-visible" : ""}`} key={i}>
                <span className="lp-stat-icon" aria-hidden="true">{s.icon}</span>
                <span className="lp-stat-num" aria-label={`${s.num}${s.suffix}`}>
                  <AnimatedCounter target={s.num} suffix={s.suffix} visible={statsVisible} />
                </span>
                <span className="lp-stat-label">{t(T[s.labelKey], lang)}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── WHY CHOOSE US ──────────────────────────────────── */}
      <section className="lp-why lp-section" aria-label="Why choose TCPL">
        <div className="lp-container">
          <div className="lp-section-header">
            <div className="lp-section-eyebrow lp-section-eyebrow-ember">Why Choose TCPL</div>
            <h2 className="lp-section-title lp-why-title">India's Most Trusted Thermal Power Contractor</h2>
            <p className="lp-section-sub lp-section-sub-dark">Proven excellence across 50+ landmark power projects spanning 14+ years</p>
          </div>
          <div className="lp-why-grid">
            {[
              { icon: "🏅", num: "50+", label: "Projects Delivered", desc: "Successfully executed 50+ major mechanical contracts across India's top power and industrial plants." },
              { icon: "🔬", num: "IBR", label: "Certified Welding", desc: "All pressure piping work performed by IBR-certified welders with full radiography and NDT compliance." },
              { icon: "🛡️", num: "Zero", label: "Compromise Safety", desc: "Dedicated safety officers on every site. All works comply with OSHA, IS codes and plant-specific HSE requirements." },
              { icon: "⚡", num: "24hr", label: "Response Time", desc: "Emergency shutdown response within 24 hours. Rapid mobilization for planned and unplanned outages." },
              { icon: "🗺️", num: "8+", label: "States Covered", desc: "Operations across Jharkhand, Odisha, Chhattisgarh, West Bengal, Bihar, Haryana, Gujarat, and Rajasthan." },
              { icon: "👷", num: "500+", label: "Skilled Workforce", desc: "Permanent roster of trained welders, fitters, riggers, supervisors and safety professionals." },
            ].map((item, i) => (
              <div className="lp-why-card" key={i}>
                <div className="lp-why-card-num">{item.num}</div>
                <div className="lp-why-card-icon">{item.icon}</div>
                <div className="lp-why-card-label">{item.label}</div>
                <div className="lp-why-card-desc">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── ABOUT ──────────────────────────────────────────── */}
      <section className="lp-about lp-section" id="about" aria-label="About us" ref={aboutRef}>
        <div className="lp-container">
          <div className="lp-about-content">
            <div className={`lp-about-text lp-animate-left${aboutVisible ? " lp-visible" : ""}`}>
              <div className="lp-section-eyebrow">{t(T.aboutUs, lang)}</div>
              <h2 className="lp-about-title">
                India's Trusted<br /><span className="lp-about-title-accent">Thermal Power</span><br />Construction Partner
              </h2>
              <p className="lp-about-desc">
                Trishivanay Construction Private Limited (TCPL) is a DPIIT-recognised startup operating under
                Ananya Engineering Group. With 14+ years of proven expertise in mechanical construction and
                industrial contracting, we have successfully delivered 50+ major projects across India's
                leading power, cement, and infrastructure companies. Our group firms — Ojha Constructions,
                Ananya Engineering, and Shiv Shakti Enterprises — provide end-to-end mechanical solutions
                from procurement to commissioning.
              </p>
              <ul className="lp-about-list" aria-label="Key services">
                {["Mechanical Industrial Contracting","Boiler Works & IBR Piping","ESP & Ash Management Systems",
                  "Cooling Tower & Chimney Works","Project Planning & Supervision","Safety & Compliance Monitoring",
                  "Workforce & Site Management","Heavy Equipment Operation & Rental"
                ].map((s, i) => (
                  <li key={i}>
                    <span className="lp-about-check" aria-hidden="true">✓</span>
                    {s}
                  </li>
                ))}
              </ul>
              <div className="lp-about-cta">
                <button className="lp-btn-primary" onClick={() => navigate("/about")}>{t(T.learnMore, lang)}</button>
                <button className="lp-btn-outline" onClick={() => navigate("/contact")}>{t(T.contactUs, lang)}</button>
              </div>
              <div className="lp-certs">
                <div className="lp-cert-badge lp-cert-badge-gold">
                  <span className="lp-cert-icon">🇮🇳</span>
                  <div>
                    <div className="lp-cert-title">{t(T.dpiitFull, lang)}</div>
                    <div className="lp-cert-sub">Startup India — Dept. of Promotion of Industry &amp; Internal Trade</div>
                  </div>
                </div>
                <div className="lp-cert-badge lp-cert-badge-blue">
                  <span className="lp-cert-icon">🏭</span>
                  <div>
                    <div className="lp-cert-title">{t(T.msmeFull, lang)}</div>
                    <div className="lp-cert-sub">Udyam Registered — Ministry of MSME, Govt. of India</div>
                  </div>
                </div>
              </div>
            </div>

            <div className={`lp-about-cards lp-animate-right${aboutVisible ? " lp-visible" : ""}`}>
              {[
                { icon: "🔬", title: "Full Transparency", text: "Every project is executed with complete cost visibility and regular client updates at each milestone." },
                { icon: "🤝", title: "Trusted Partner", text: "14+ years of trusted partnerships with leading power and industrial corporations across India." },
                { icon: "📋", title: "Documented Process", text: "ISO-aligned work practices with documented SOPs, safety compliance, and timely delivery commitments." },
                { icon: "⚡", title: "Zero Compromise", text: "Uncompromising standards on quality, safety, and ethics — every step, every project, every time." },
                { icon: "🏆", title: "Award-Winning Quality", text: "Recognized by NTPC, Adani, Tata Power and BHEL for consistent quality and on-time project delivery." },
              ].map((card, i) => (
                <div className="lp-about-card" key={i}>
                  <div className="lp-about-card-icon" aria-hidden="true">{card.icon}</div>
                  <div className="lp-about-card-title">{card.title}</div>
                  <div className="lp-about-card-text">{card.text}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ─── TRUST STRIP ────────────────────────────────────── */}
      <section className="lp-trust" aria-label="Our values" ref={trustRef}>
        <div className="lp-container">
          <div className="lp-trust-grid">
            {[
              { icon: "🔒", title: "ISO-Aligned Processes", desc: "Standardized work processes with full compliance, QA/QC and IBR certification." },
              { icon: "🎯", title: "On-Time Delivery", desc: "Proven track record of delivering projects on schedule across 50+ major contracts." },
              { icon: "🛡️", title: "Safety First", desc: "Zero-compromise safety culture with dedicated safety officers on every site." },
              { icon: "📐", title: "Engineering Excellence", desc: "Precision engineering backed by 14+ years of hands-on thermal power expertise." }
            ].map((item, i) => (
              <div className={`lp-trust-item lp-animate lp-animate-delay-${i+1}${trustVisible ? " lp-visible" : ""}`} key={i}>
                <span className="lp-trust-icon" aria-hidden="true">{item.icon}</span>
                <div className="lp-trust-title">{item.title}</div>
                <div className="lp-trust-desc">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── SERVICES ───────────────────────────────────────── */}
      <section className="lp-services lp-section" id="services" aria-label="Our services" ref={servicesRef}>
        <div className="lp-container">
          <div className={`lp-section-header lp-animate${servicesVisible ? " lp-visible" : ""}`}>
            <div className="lp-section-eyebrow lp-section-eyebrow-ember">{t(T.servicesTitle, lang)}</div>
            <h2 className="lp-section-title lp-services-title">{t(T.servicesTitle, lang)}</h2>
            <p className="lp-section-sub lp-services-sub">{t(T.servicesSub, lang)}</p>
          </div>
          <div className="lp-services-grid">
            {constructionWorks.map((svc, i) => (
              <article
                className={`lp-service-card lp-animate lp-animate-delay-${(i % 4) + 1}${servicesVisible ? " lp-visible" : ""}`}
                key={i}
                onClick={() => setSelectedService(svc)}
                role="button"
                tabIndex={0}
                aria-label={`${svc.title} — click for details`}
                onKeyDown={(e) => { if (e.key === "Enter") setSelectedService(svc); }}
              >
                <button className="lp-service-info-btn" onClick={(e) => { e.stopPropagation(); setSelectedService(svc); }} aria-label={`More info about ${svc.title}`}>ℹ</button>
                <div className="lp-service-icon" aria-hidden="true">{svc.icon}</div>
                <h3 className="lp-service-title">{svc.title}</h3>
                <p className="lp-service-desc">{svc.description}</p>
                <span className="lp-service-count">{svc.subItems.length} Scope Items</span>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ─── OUR PROCESS ────────────────────────────────────── */}
      <section className="lp-process lp-section" aria-label="Our work process">
        <div className="lp-container">
          <div className="lp-section-header">
            <div className="lp-section-eyebrow lp-section-eyebrow-ember">How We Work</div>
            <h2 className="lp-section-title lp-process-title">Our Proven Project Methodology</h2>
            <p className="lp-section-sub lp-process-sub">From enquiry to handover — a structured, transparent process that delivers quality on time</p>
          </div>
          <div className="lp-process-grid">
            {[
              { step: "01", icon: "📋", title: "Enquiry & Scope Review", desc: "You share your project scope, drawings, and timeline. We review and respond within 24 hours with preliminary assessment." },
              { step: "02", icon: "💼", title: "Site Visit & Estimation", desc: "Our senior engineers visit the site, assess logistics, and prepare a detailed BOQ with realistic cost and schedule." },
              { step: "03", icon: "📝", title: "Contract & Mobilization", desc: "Agreement signed with clear milestones. Workforce, equipment and material procurement begins immediately." },
              { step: "04", icon: "⚙️", title: "Execution & QA", desc: "Works executed as per approved drawings with daily progress reports, QA/QC checks and safety audits at every stage." },
              { step: "05", icon: "✅", title: "Testing & Commissioning", desc: "Hydro testing, NDT, pre-commissioning checks and final handover with full documentation and test certificates." },
            ].map((step, i) => (
              <div className="lp-process-step" key={i}>
                <div className="lp-process-num">{step.step}</div>
                <div className="lp-process-icon">{step.icon}</div>
                <h3 className="lp-process-title-item">{step.title}</h3>
                <p className="lp-process-desc">{step.desc}</p>
                {i < 4 && <div className="lp-process-arrow">→</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── PROJECTS ───────────────────────────────────────── */}
      <section className="lp-projects lp-section" id="projects" aria-label="Our projects" ref={projectsRef}>
        <div className="lp-container">
          <div className={`lp-section-header lp-animate${projectsVisible ? " lp-visible" : ""}`}>
            <div className="lp-section-eyebrow lp-section-eyebrow-blue">{t(T.projectsTitle, lang)}</div>
            <h2 className="lp-section-title lp-projects-title">{t(T.projectsTitle, lang)}</h2>
            <p className="lp-section-sub lp-section-sub-dark">{t(T.projectsSub, lang)}</p>
          </div>
          <CircularSlider images={workImages} speed={1} />
        </div>
      </section>

      {/* ─── CLIENTS ────────────────────────────────────────── */}
      <section className="lp-clients lp-section" id="clients" aria-label="Our clients" ref={clientsRef}>
        <div className="lp-container">
          <div className={`lp-section-header lp-animate${clientsVisible ? " lp-visible" : ""}`}>
            <div className="lp-section-eyebrow">{t(T.clientsTitle, lang)}</div>
            <h2 className="lp-section-title lp-clients-title">{t(T.clientsTitle, lang)}</h2>
            <p className="lp-section-sub lp-clients-sub">{t(T.clientsSub, lang)}</p>
          </div>
          <div className="lp-clients-grid">
            {clientsList.map((c, i) => (
              <article className={`lp-client-card lp-animate lp-animate-delay-${(i%4)+1}${clientsVisible?" lp-visible":""}`} key={i}>
                <h3 className="lp-client-name">{c.name}</h3>
                <span className="lp-client-type">{c.type}</span>
                <p className="lp-client-desc">{c.description}</p>
              </article>
            ))}
          </div>
          <div className="lp-clients-logos-head" aria-hidden="true">— OUR PARTNERS —</div>
          <CircularSlider images={clientLogos} speed={2} />
        </div>
      </section>

      {/* ─── INDUSTRIES SERVED ──────────────────────────────── */}
      <section className="lp-industries lp-section" aria-label="Industries served">
        <div className="lp-container">
          <div className="lp-section-header">
            <div className="lp-section-eyebrow lp-section-eyebrow-cyan">Industries</div>
            <h2 className="lp-section-title lp-industries-title">Sectors We Serve</h2>
            <p className="lp-section-sub lp-section-sub-dark">Specialized expertise across India's critical industrial infrastructure</p>
          </div>
          <div className="lp-industries-grid">
            {[
              { icon: "⚡", title: "Thermal Power Plants", desc: "Coal-based thermal power plants ranging from 210MW to 800MW+. Full mechanical scope from boiler to balance of plant.", tag: "Primary" },
              { icon: "🏭", title: "Cement Plants", desc: "Kiln mechanical works, conveyor systems, material handling, and auxiliary equipment installation.", tag: "Active" },
              { icon: "🔩", title: "Steel & Metallurgy", desc: "Industrial mechanical contracting for steel plants, smelters and metallurgical facilities.", tag: "Active" },
              { icon: "💧", title: "Water Treatment", desc: "Piping, pumping systems, and mechanical works for water treatment and ETP/STP facilities.", tag: "Active" },
              { icon: "🏗️", title: "Infrastructure & Township", desc: "Area development, horticulture, internal roads, drainage and township development for industrial projects.", tag: "Active" },
              { icon: "🌱", title: "FGD & Environment", desc: "Flue gas desulfurization systems for emission compliance at operating and greenfield power stations.", tag: "Growing" },
            ].map((ind, i) => (
              <div className="lp-industry-card" key={i}>
                <div className="lp-industry-icon">{ind.icon}</div>
                <span className="lp-industry-tag">{ind.tag}</span>
                <h3 className="lp-industry-title">{ind.title}</h3>
                <p className="lp-industry-desc">{ind.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── PROJECT LOCATIONS ──────────────────────────────── */}
      <section className="lp-locations lp-section" aria-label="Project locations across India">
        <div className="lp-container">
          <div className="lp-section-header">
            <div className="lp-section-eyebrow lp-section-eyebrow-ember">Pan-India Presence</div>
            <h2 className="lp-section-title lp-loc-title">Where We've Delivered</h2>
            <p className="lp-section-sub lp-section-sub-dark">Projects spanning 8+ states and 20+ major industrial locations across India</p>
          </div>
          <div className="lp-locations-grid">
            {[
              { state: "Jharkhand", icon: "🏭", projects: ["NTPC Tandwa", "NTPC Buxar (Chausa)", "Maithon Power — Dhanbad", "Tata Power Jamshedpur", "NKSTPP — Hajaribag"] },
              { state: "Odisha", icon: "⚡", projects: ["Vedanta Aluminium — Jharsuguda", "STEAG Energy — Jharsuguda", "NTPC NGSL Vedanta"] },
              { state: "Chhattisgarh", icon: "🔥", projects: ["Lanco Infratech — Korba", "KSK Mahanadi — Akaltara", "Ambuja Cement — Bhatapara"] },
              { state: "Madhya Pradesh", icon: "🏗️", projects: ["TPSC Toshiba — Anuppur"] },
              { state: "Haryana", icon: "💨", projects: ["CLP India — Jhajjar"] },
              { state: "Gujarat & West Bengal", icon: "🌏", projects: ["Adani Power — Gujarat", "BHEL Sagardighi — W.B."] },
            ].map((loc, i) => (
              <div className="lp-location-card" key={i}>
                <div className="lp-location-icon">{loc.icon}</div>
                <h3 className="lp-location-state">{loc.state}</h3>
                <ul className="lp-location-list">
                  {loc.projects.map((p, j) => <li key={j}>{p}</li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── CONTACT ────────────────────────────────────────── */}
      <section className="lp-contact lp-section" id="contact" aria-label="Contact information" ref={contactRef}>
        <div className="lp-container">
          <div className={`lp-section-header lp-animate${contactVisible ? " lp-visible" : ""}`}>
            <div className="lp-section-eyebrow lp-section-eyebrow-teal">{t(T.contactTitle, lang)}</div>
            <h2 className="lp-section-title lp-contact-title">{t(T.contactTitle, lang)}</h2>
            <p className="lp-section-sub lp-section-sub-dark">{t(T.contactSub, lang)}</p>
          </div>
          <div className="lp-contact-grid">
            <div className={`lp-contact-info lp-animate-left${contactVisible ? " lp-visible" : ""}`}>
              <a href="mailto:arunojha@trishivanay.com" className="lp-contact-card" aria-label="Send email">
                <div className="lp-contact-card-icon" aria-hidden="true">✉️</div>
                <div>
                  <div className="lp-contact-card-label">Email</div>
                  <div className="lp-contact-card-value">arunojha@trishivanay.com</div>
                  <div className="lp-contact-card-desc">We reply within 24 hours</div>
                </div>
              </a>
              <a href="tel:+916200247745" className="lp-contact-card" aria-label="Call us">
                <div className="lp-contact-card-icon" aria-hidden="true">📞</div>
                <div>
                  <div className="lp-contact-card-label">Phone</div>
                  <div className="lp-contact-card-value">+91 6200247745</div>
                  <div className="lp-contact-card-desc">Mon–Sat, 9am – 6pm IST</div>
                </div>
              </a>
              <div className="lp-contact-card" style={{ cursor: "default" }} aria-label="Office address">
                <div className="lp-contact-card-icon" aria-hidden="true">📍</div>
                <div>
                  <div className="lp-contact-card-label">Address</div>
                  <div className="lp-contact-card-value">Jamshedpur, Jharkhand</div>
                  <div className="lp-contact-card-desc">Shiv Singh Bagan, 23B GTBN, Dist. East Singhbhum — 831009</div>
                </div>
              </div>
              <button className="lp-wa-btn" onClick={() => window.open("https://wa.me/916200247745","_blank","noopener,noreferrer")} aria-label="Chat on WhatsApp">
                <span style={{ fontSize: "1.4rem" }} aria-hidden="true">💬</span>
                <div style={{ textAlign: "left" }}>
                  <div style={{ fontWeight: 800 }}>WhatsApp Chat</div>
                  <div style={{ fontSize: "0.8rem", opacity: 0.8 }}>Quick response guaranteed</div>
                </div>
              </button>
              <button className="lp-btn-primary" onClick={() => navigate("/contact")} style={{ width: "100%", fontSize: "1rem" }}>
                {t(T.sendMessage, lang)}
              </button>
            </div>
            <div className={`lp-animate-right${contactVisible ? " lp-visible" : ""}`}>
              <div className="lp-map">
                <iframe
                  title="Trishivanay Construction Office Location — Jamshedpur"
                  src="https://www.google.com/maps?q=Shiv+Singh+Bagan,+23B+GTBN,+Post-+Agrico,+PS-+Sidhgora,+Dist-+East+Singhbhum,+Jamshedpur,+Jharkhand,+831009&output=embed"
                  width="100%" height="500"
                  style={{ border: 0, display: "block" }}
                  allowFullScreen loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── WORK WITH US ───────────────────────────────────── */}
      <section className="lp-work lp-section" aria-label="Work with us" ref={workRef}>
        <div className="lp-container">
          <div className={`lp-section-header lp-animate${workVisible ? " lp-visible" : ""}`}>
            <div className="lp-section-eyebrow">{t(T.workWithUs, lang)}</div>
            <h2 className="lp-section-title lp-work-title">{t(T.workWithUs, lang)}</h2>
            <p className="lp-section-sub lp-work-sub">{t(T.workWithUsSub, lang)}</p>
          </div>
          <div className="lp-work-grid">
            <div className={`lp-work-card lp-work-card-blue lp-animate-left${workVisible ? " lp-visible" : ""}`}>
              <div className="lp-work-card-icon" aria-hidden="true">👷</div>
              <h3 className="lp-work-card-title">{t(T.joinWorkforce, lang)}</h3>
              <p className="lp-work-card-desc">{t(T.joinDesc, lang)}</p>
              <ul className="lp-work-card-list" aria-label="Job categories">
                <li>Welders, Fitters, Electricians</li>
                <li>Mechanical Engineers &amp; Supervisors</li>
                <li>Safety Officers &amp; Site Staff</li>
                <li>Pan-India project locations</li>
              </ul>
              <button className="lp-work-card-btn" onClick={() => navigate("/careers")}
                style={{ color: "#1e3a8a" }} aria-label="Apply for a job">
                {t(T.applyNow, lang)}
              </button>
            </div>
            <div className={`lp-work-card lp-work-card-gold lp-animate-right${workVisible ? " lp-visible" : ""}`}>
              <div className="lp-work-card-icon" aria-hidden="true">🏭</div>
              <h3 className="lp-work-card-title">{t(T.hireOurTeam, lang)}</h3>
              <p className="lp-work-card-desc">{t(T.hireDesc, lang)}</p>
              <ul className="lp-work-card-list" aria-label="Service categories">
                <li>Thermal Power Plant Works</li>
                <li>Industrial Mechanical Contracting</li>
                <li>Area Development &amp; Horticulture</li>
                <li>DPIIT Registered — Government Trusted</li>
              </ul>
              <button className="lp-work-card-btn" onClick={() => navigate("/hireus")}
                style={{ color: "#78350f" }} aria-label="Send a business enquiry">
                {t(T.sendEnquiry, lang)}
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* ─── Service Modal ──────────────────────────────────── */}
      {selectedService && (
        <ServiceModal category={selectedService} onClose={() => setSelectedService(null)} />
      )}
    </div>
  );
};

export default LandingPage;
